import React from "react";
import { Button } from "@mui/material";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";

const ReportButton = ({ active, onClick, label = "Circularity Report", height = "38px", dense = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Button
      disableRipple
      startIcon={<SummarizeIcon sx={{ fontSize: 16 }} />}
      onClick={onClick}
      sx={{
        borderRadius: "10px",
        height: "38px",
        minHeight: "38px",
        maxHeight: "38px",
        boxSizing: "border-box",
        px: 2,
        py: 0,
        textTransform: "none",
        fontSize: "13px",
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: "nowrap",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        
        backgroundColor: active 
          ? "#659d33" 
          : (isDark ? "rgba(101, 157, 51, 0.05)" : "rgba(101, 157, 51, 0.04)"),
        color: active 
          ? "#ffffff" 
          : "#659d33",
        border: `1px solid ${active ? "#659d33" : (isDark ? "rgba(101, 157, 51, 0.4)" : "rgba(101, 157, 51, 0.3)")}`,
        boxShadow: active 
          ? "0 2px 8px rgba(101, 157, 51, 0.3)" 
          : "none",

        "&:hover": {
          backgroundColor: active 
            ? "#557f29" 
            : (isDark ? "rgba(101, 157, 51, 0.15)" : "rgba(101, 157, 51, 0.08)"),
          borderColor: "#659d33",
          color: active ? "#ffffff" : "#659d33",
          boxShadow: active 
            ? "0 6px 20px 0 rgba(101, 157, 51, 0.5)" 
            : "0 4px 12px 0 rgba(101, 157, 51, 0.12)",
          transform: "translateY(-1px)",
        },
        "&:active": {
          transform: "translateY(0px)",
        }
      }}
    >
      {t(label)}
    </Button>
  );
};

export default ReportButton;
